import API from "src/core/Api";
import { store } from '../store'

export default {
    objectIsEmpty: (obj) => {
        for(let prop in obj) {
            // eslint-disable-next-line no-prototype-builtins
            if(obj.hasOwnProperty(prop))
                return false;
        }
        return true;
    },
    currencyFormat: (amount) => {
        // Create our number formatter.
        var formatter = new Intl.NumberFormat('en-ES', {
            style: 'currency',
            currency: 'GTQ',

            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });

        return formatter.format(amount);
    },
    copyToClipboard: (text, msg) => {

        if (!msg) msg = 'Copiado al portapapeles con éxito';
        //var text = "Example text to appear on clipboard";
        navigator.clipboard.writeText(text).then(function() {
            API.showSuccessAlert(msg);
        }, function() {
            API.showSuccessAlert('Error al copiar, el navegador no es compatible');
        });
    },
    pushToObject(object, data) {
        const tmp = {};
        let count = 0;
        for (let item in object) {
            tmp[count] = object[item];
            count++;
        }
        tmp[count] = data;
        return tmp;
    },
    stringCapitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    createSlug(string) {
        //return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").charAt(0).toLowerCase() + string.slice(1);
        const tmpSlug = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/(?!\w|\s)./g, '-').replace(/\s+/g, '-').replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2').toLowerCase();
        return this.trim(tmpSlug, '-');
    },
    createUniqueId() {
        return Date.now().toString(36) + Math.random().toString(36).substring(2);
    },
    trim(string, c) {
        if (c === "]") c = "\\]";
        if (c === "^") c = "\\^";
        if (c === "\\") c = "\\\\";
        return string.replace(new RegExp(
            "^[" + c + "]+|[" + c + "]+$", "g"
        ), "");
    },
    isEmptyString(str, strLen) {

        if (typeof str === 'undefined') return true;
        if (str === null) return true;

        str = String(str);
        if (!strLen) {
            return (str === null || str.match(/^ *$/) !== null || str === '');
        }
        else {
            return ((str === null || str.match(/^ *$/) !== null || str === '') || (str.length < strLen));
        }
    },
    checkPasswordStrength(password) {
        //Regular Expressions
        const regex = [];
        regex.push("[A-Z]"); //For Uppercase Alphabet
        regex.push("[a-z]"); //For Lowercase Alphabet
        regex.push("[0-9]"); //For Numeric Digits
        regex.push("[$@$!%*#?&-.;=+]"); //For Special Characters

        let passed = 0;

        //Validation for each Regular Expression
        for (var i = 0; i < regex.length; i++) {
            if ((new RegExp(regex[i])).test(password)) {
                passed++;
            }
        }

        //Validation for Length of Password
        if (passed > 2 && password.length > 8) {
            passed++;
        }

        //Display of Status
        let color = "";
        let passwordStrength = "";
        switch (passed) {
            case 0:
                break;
            case 1:
                passwordStrength = "La contraseña es débil";
                color = "#d72d2d";
                break;
            case 2:
                passwordStrength = "La contraseña es débil";
                color = "darkorange";
                break;
            case 3:
                passwordStrength = "La contraseña es débil";
                break;
            case 4:
                passwordStrength = "La contraseña es fuerte";
                color = "Green";
                break;
            case 5:
                passwordStrength = "La contraseña es muy fuerte";
                color = "darkgreen";
                break;
        }

        return {
            passwordStrength: passed,
            passwordStrengthMsg: passwordStrength,
            passwordStrengthColor: color,
        }
    },
    getLocation(callback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(callback);
        }
        else {
            callback(false);
        }
    },
    parseObjectToFloat(data) {
        const parse = function (data) {
            for (let key in data) {
                const n = parseFloat(data[key])
                if (typeof data[key] == 'object') parse(data[key]);
                if (n && !isNaN(n)) data[key] = n;
            }
            return data;
        }
        return parse(data);
    },
    // para check de accesos y configuraciones
    check: {
        config(module, key) {
            const config = (store.getters.AuthGetUserInfo.configuration) ? store.getters.AuthGetUserInfo.configuration : {};
            if (typeof config[module] !== 'undefined') {
                if (typeof config[module][key] !== 'undefined') {
                    return config[module][key];
                }
            }
            return false;
        },
        access(key) {
            const access = (store.getters.storeAccessQuota) ? store.getters.storeAccessQuota : {};
            if (typeof access[key] !== 'undefined' && access[key]['s']) {
                return access[key];
            }
            return false;
        },
    },
    validateEmail(email){
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    },
    stripTags(text) {
        return text.replace(/<\/?[^>]+(>|$)/g, "");
    },
}
